import { createActionGroup, props, emptyProps } from '@ngrx/store';

export const LeadBankActions = createActionGroup({
  source: 'LeadBank',
  events: {
    'Load Lead Banks': emptyProps(),
    'Load Lead Banks Success': props<{ leadBanks: any[] }>(),
    'Load Lead Banks Failure': props<{ error: any }>(),

    'Validate Email': props<{ email: string }>(),
    'Validate Email Success': props<{
      result: {
        sts: string;
        correctedEmail?: string;
        existingEmailMatches?: string[];
        message?: string;
      };
    }>(),
    'Validate Email Failure': props<{ error: any }>(),

    'Submit External Invest': props<{ payload: any }>(),
    'Submit External Invest Success': props<{ payload: any }>(),
    'Submit External Invest Failure': props<{ error: any }>(),

    'Clear Validation': emptyProps(),
  },
});
